<template>
    <div>
        <top :refresh="refreshBanner"></top>
        <zixun></zixun>
        <cunzheng></cunzheng>
        <dci></dci>
        <jiance></jiance>
    </div>
</template>

<script>
    import top from './components/indexone/index.vue';
    import zixun from './components/indextwo/index.vue';
    import cunzheng from './components/indexthree/index.vue';
    import dci from './components/indexfour/index.vue';
    import jiance from './components/indexfive/index.vue';
    import {_getShowPopup,_getUnloginPopup} from '../../../api/activity.js'
    import EventBus from "@/libs/eventBus"

    export default {
        metaInfo: {
            title: '版权登记|版权保护-版权服务专家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权登记,版权保护,版权登记查询,版权保护中心,版权保护服务,版权登记服务,版权家'
            },{
                name: 'Description',
                content: '版权家是专业提供版权登记查询，版权保护申请；我们作为版权保护服务专家，为版权人提供极致的版权登记咨询、版权交易、版权监测、版权维权等服务体验。'
            }]
        },
        name:'firstPage',
        components:{
            top,
            zixun,
            cunzheng,
            dci,
            jiance
        },
        data(){
            return {
                showModal:false,
                refreshBanner:0,
                refreshVipeight:0,
                activeFloating:false
            }
        },

        methods:{
            fatherModal() {
                this.showModal = false;
            },
            //跳转426活动
			copyright_registration(){
				// this.currPath=this.$route.path
				this.$router.push({
					path:'/huodong/zhishichanquanri.html'
				})
			},
            modalFun(){              
                _getShowPopup().then(res=>{   
                    if(res.code==200){
                        this.showModal=res.result.popup
                    }
                })
            },
            unloginPopup(){
                _getUnloginPopup().then(res=>{   
                    if(res.code==200){
                        this.showModal=res.result.popup
                    }
                })
            },

            updateBanner(){
                this.refreshBanner = new Date().getTime();
                this.refreshVipeight = new Date().getTime()+1;
            },
            //截取百度搜索关键字
            queryString(parm,parm2){
                var baiduKeyWords = "";
                let fromUrl = parm2.split("?");
                let fromUrl2=fromUrl[1].split("&");
                let wordsArr = fromUrl2.filter(item=>item.match(parm))
                let wordsArr2 = wordsArr.join("").split("=")
                return baiduKeyWords=wordsArr2[1]                               
            },
            //获取跳转到版权家官网首页的路径
            getWord(){
                if(window.document.referrer){
                    // 获取上级页面
                    let url = document.referrer;
                    // 判断是不是百度的域名
                    if(url.match("www.baidu.com")) {
                        // 第一个参数是百度的get参数wd拼接的关键词
                        let mywords = this.queryString("wd",url);
                        if(mywords != '') console.log(decodeURI(mywords));
                        // 判断是不是百度手机端
                    }else if(url.match("m.baidu.com")){
                        let mywords = this.queryString("word",url);
                        if(mywords != '') console.log(decodeURI(mywords));
                    }else{
                        console.log(url+'不是从百度搜索来的')
                    }
                }else{
                    console.log("没有document.referrer属性")
                }
            },

            //跳转页面方法
            jumpRouter(url){
                window.open(url)
            }
        },
        mounted(){
            this.getWord();
        },
        created(){
            //未登录
            //this.unloginPopup()
            //已登录        
            let aaa = 0
            EventBus.on('showModalFun',(aaa)=>{
                console.log('登录了jj')
                this.modalFun();
                this.updateBanner();
            });


            EventBus.on('logout',(aaa)=>{
                console.log('退出了out')
                this.updateBanner();

            })

        },
        beforeDestroy(){
            EventBus.off('showModalFun');

            EventBus.off('logout')
        },

    }
</script>

<style scoped lang="less">
    .active_floating{
        position: fixed;
        z-index: 999;
        cursor: pointer;

        &.double_twelve{
            bottom: 20%;
            right: 0;
            width: 118px;
            height: 118px;
            background: url(./images/activity/double_twelve_bg.png) no-repeat left center;
            background-size: 105px 80px;
            box-sizing: border-box;

            .active_floating_close{
                display: block;
                width: 17px;
                height: 17px;
                margin: 17px 0 0 7px;
                cursor: pointer;

            }
        }
    }
.copyright_icon{
    position: fixed;
    right: 16px;
    bottom: 150px;
    z-index: 999;
    width: 150px;
    height: 140px;
    cursor: pointer;
    .copyright_img{
        width: 150px;
        height: 140px;
    }
}
</style>